export const ev = [
    {
        "anio" : "Programa Anual de Evaluación",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "2026",
                "url" : "/Evgral"
            },
            /*{
                "trimestre" : "Segunda Sesión 2024",
                "url" : "/pdf/2Acocodi.pdf"
            },
            {
                "trimestre" : "Tercera Sesión 2024",
                "url" : "/pdf/3Acocodi.pdf"
            },
            {
                "trimestre" : "Cuarta Sesión 2024",
                "url" : "/pdf/4Acocodi.pdf"
            },
            {
                "trimestre" : "Primera Sesión 2025",
                "url" : "/pdf/1A25cocodi.pdf"
            },*/
            
        ]
    },
    {
        "anio" : "",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Programa Anual de Evaluación",
                "url" : "/pdf/PAE2026.pdf"
            },
            {
                "trimestre" : "Evaluación",
                "url" : "/Ev2026"
            },
            {
                "trimestre" : "Monitoreo",
                "url" : "/Pr2026"
            },
            
            
        ]
    },
    {
        "anio" : "",
        "descripcion" : "Evaluación",
        "trimestres" : [
            {
                "trimestre" : "Evaluación Especifica del Desempeño",
                "url" : "/Ev2026"
            },
            {
                "trimestre" : "Evaluación de Diseño",
                "url" : "/Ev2026"
            },
            {
                "trimestre" : "Evaluación de Consistencia y Resultados",
                "url" : "/Ev2026"
            },
            {
                "trimestre" : "Evaluación de Procesos",
                "url" : "/Ev2026"
            },
            {
                "trimestre" : "Evaluación de Impacto",
                "url" : "/Ev2026"
            }
            
            
        ]
    }
]